  <app-modal [(visible)]="isChangeOwnerVisible" header="CHANGE OWNER AND ASSIGN" (visibleChange)="visibleChange($event)">
    <form [formGroup]="formGroup">
      <div class="p-grid p-fluid basic-filter">
        <div class="p-col-12 p-md-12 p-lg-12 modal-label">New Owner</div>
        <div class="p-col-12 p-md-12 p-lg-12 change-owner-select">
          <app-button class="header-button" text="REVELEER" [styleClass]="hdviButtonStyle" (onClick)="getUsersDropdown('O')"></app-button>&nbsp;&nbsp;
          <app-button class="header-button" text="Customer" [styleClass]="clientButtonStyle" (onClick)="getUsersDropdown('C')"></app-button>
        </div>
        <div class="p-col-6 p-md-6 p-lg-6">          
          <form-factory [formGroup]="formGroup" [model]="assignedUsers"></form-factory>
        </div>
        <div class="p-col-12 p-md-12 p-lg-12">
          <form-factory [formGroup]="formGroup" [model]="notes"></form-factory>
        </div>
      </div>
    </form>
    <footer>
      <app-button class="header-button" text="FINISH" (onClick)="changeOwner()"></app-button>
    </footer>
</app-modal>
